import type { BookingSessionResponse } from '@massilia/queries'

import { InformationsForm } from './informations-form'
import { InformationsLoadingSkeleton } from './loading-skeleton'

interface InformationsPageProps {
  sessionId: string
  isLoading: boolean
  isPriceLoading: boolean
  session?: BookingSessionResponse
}

export function InformationsPage({
  sessionId,
  isLoading,
  isPriceLoading,
  session,
}: InformationsPageProps) {
  if (isLoading && !session) {
    return <InformationsLoadingSkeleton />
  }

  return (
    <InformationsForm isPriceLoading={isPriceLoading} session={session} sessionId={sessionId} />
  )
}
